/* ==========================================================================
   Related Products — fetches Shopify product recommendations and renders
   cards using the existing trending-product-card snippet.

   Uses Shopify's native /recommendations/products endpoint — same engine
   the Horizon theme uses (collaborative filtering + complementary products).
   ========================================================================== */

(function () {
  'use strict';

  function fetchRecommendations(section) {
    const url = section.dataset.url;
    if (!url) return;

    fetch(url)
      .then((res) => {
        if (!res.ok) throw new Error('Recommendations fetch failed');
        return res.text();
      })
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        // Shopify wraps the section response — pull just the inner section
        const newSection = doc.querySelector('[data-related-products]');
        if (!newSection) {
          // No recommendations returned — hide the section
          section.dataset.empty = 'true';
          return;
        }

        const newContainer = newSection.querySelector('.trending-products__container');
        if (!newContainer) {
          section.dataset.empty = 'true';
          return;
        }

        const currentContainer = section.querySelector('.trending-products__container');
        if (currentContainer) {
          currentContainer.innerHTML = newContainer.innerHTML;
        } else {
          section.appendChild(newContainer);
        }

        // Re-init the trending-products behaviors (cart, wishlist, slider)
        // for the freshly injected cards.
        if (window.TrendingProducts && typeof window.TrendingProducts.init === 'function') {
          delete section.dataset.tpInit;
          window.TrendingProducts.init(section);
        }

        // Notify listeners (analytics, etc.)
        section.dispatchEvent(
          new CustomEvent('related-products:loaded', { bubbles: true })
        );
      })
      .catch((err) => {
        console.warn('[related-products]', err);
        section.dataset.empty = 'true';
      });
  }

  function init(root) {
    (root || document).querySelectorAll('[data-related-products]').forEach((section) => {
      if (section.dataset.rpInit) return;
      section.dataset.rpInit = '1';

      // If the section was already rendered server-side with products
      // (recommendations.performed was true on first load), skip the fetch.
      const hasCards = section.querySelector('.tp-card:not(.tp-card--skeleton)');
      if (hasCards) {
        return; // trending-products.js will already have wired up cart/wishlist
      }

      fetchRecommendations(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (e) => init(e.target));
  document.addEventListener('shopify:section:select', (e) => init(e.target));
})();